;(function (): void {
    const me = document.currentScript as HTMLScriptElement | null
    if (!me) {
        return
    }

    // `src` is a reflected URL attribute, so the browser has already resolved it to an absolute
    // URL — unlike getAttribute('src'), which can be relative and would make `new URL()` throw.
    // It is '' when the attribute is absent, in which case there is nothing to locate.
    const loaderSrc = me.src
    if (!loaderSrc) {
        return
    }

    // data-on-demand-id is what the host-side snippet generator emits; the value is the event id.
    // data-event-id is accepted as an alias for consistency with the live loader and the local
    // test harness. Without either there is nothing to register against, so skip the download.
    const eventId = me.getAttribute('data-on-demand-id') || me.getAttribute('data-event-id')
    if (!eventId) {
        return
    }

    // The loader is self-locating: it derives the bundle path from wherever it was served, so the
    // same file works from localhost, assets.riverside.fm and assets.riverside.com unconfigured.
    const loaderUrl = new URL(loaderSrc)
    const base = `${loaderUrl.origin}${loaderUrl.pathname.substring(0, loaderUrl.pathname.lastIndexOf('/'))}`

    const ver = me.getAttribute('data-version') || 'latest'
    // On-demand bundles live in their own subtree so this widget versions independently of the
    // live one; the loader itself stays at the prefix root next to loader.js.
    const src = `${base}/on-demand/${ver}/rs-webinar-on-demand-form.min.js`

    if (window.__RV_WOD_LOADING__) {
        return
    }
    window.__RV_WOD_LOADING__ = true

    const s = document.createElement('script')
    s.src = src
    s.async = true
    s.crossOrigin = 'anonymous'
    s.onerror = function (): void {
        window.__RV_WOD_LOADING__ = false
    }
    s.onload = function (): void {
        if (typeof window.RV_WOD_INIT === 'function') {
            // Init owns its own error reporting; catching here keeps a rejection from surfacing as
            // an unhandled rejection on the host page and tripping the host's error monitoring.
            window
                .RV_WOD_INIT({
                    apiBase: me.getAttribute('data-api-base') || 'https://riverside.com',
                    graphqlEndpoint: me.getAttribute('data-graphql-endpoint') || 'https://riverside.com/graphql',
                    eventId,
                    // Defaults to the container the generated snippet ships with. Never 'body' — the
                    // widget replaces its mount's children, which would wipe the host page.
                    target: me.getAttribute('data-target') || '#riverside-on-demand',
                    labels: tryJSON(me.getAttribute('data-labels')) || null,
                    // Optional override; without it the widget follows the event's language.
                    language: me.getAttribute('data-language') || null,
                })
                .catch((): void => {
                    window.__RV_WOD_LOADING__ = false
                })
        }
    }
    document.head.appendChild(s)

    function tryJSON(jsonString: string | null): any {
        if (!jsonString) {
            return null
        }
        try {
            return JSON.parse(jsonString)
        } catch (_err) {
            return null
        }
    }
})()
